import { Field } from 'formik';
import { NodeLogo } from '../../../shared/components/NodeLogo/NodeLogo';
import { FormControl } from '../../../shared/components/FormControl/FormControl';
import { FormikAsyncValidatedTextField } from '../../../input/FormikAsyncValidatedTextField/FormikAsyncValidationTextField';
import { getDataIdsFromContract } from '../../../shared/utils/dataId';
import { TEMPLATE_FORM_NAME_FIELD_DATA_IDS } from './templateFormNameFieldDataId';
import { TemplateFormFieldProps } from '../../interfaces/template-form';
import { TemplateFormNameFieldMeta } from './interfaces/template-form-name-field-meta';

export function TemplateFormNameField({ field, metadata, formDisabled }: TemplateFormFieldProps) {
  const { label, placeholder, logo, logoDarkMode, title, disabled, description } =
    metadata as TemplateFormNameFieldMeta;

  const dataIds = getDataIdsFromContract(TEMPLATE_FORM_NAME_FIELD_DATA_IDS, `${field.name}-field`);

  return (
    <div className='d-flex'>
      <div className='center-flex-row flex-1'>
        <NodeLogo
          dataId={dataIds.nodeLogo}
          logoURL={logo!}
          darkModeLogoURL={logoDarkMode!}
          size={5}
        />

        <div data-id={dataIds.label} className='flex-col ml-2'>
          <span className='text-medium'>{title}</span>
          <span className='text-secondary mt-1'>{description}</span>
        </div>
      </div>

      <div className='flex-1 ml-5'>
        <FormControl>
          <Field
            name={field.name}
            label={label}
            placeholder={placeholder}
            component={FormikAsyncValidatedTextField}
            autoFocus
            required
            disabled={disabled || formDisabled}
            maxLength={255}
          />
        </FormControl>
      </div>
    </div>
  );
}
